<div class="container">
    <div mat-dialog-content>
        <div mat-dialog-title class="header3">Add new container</div>
        <form [formGroup]="containerForm" autocomplete="off" novalidate (ngSubmit)="createContainer(containerForm.value)"
            fxLayout="column wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" id="name" type="text">
                <mat-hint align="end">No more then 30 characters long.</mat-hint>
                <mat-error *ngIf="hasError('name', 'required')">Name is required</mat-error>
                <mat-error *ngIf="hasError('name', 'maxlength')">You have more than 30 characters</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Description</mat-label>
                <textarea matInput formControlName="description" id="description" type="text"></textarea>
                <mat-hint align="end">Atleast 40 Characters</mat-hint>
                <mat-error *ngIf="hasError('description', 'required')">Description is required</mat-error>
                <mat-error *ngIf="hasError('description', 'maxlength')">Can't include more than 400 characters</mat-error>
                <mat-error *ngIf="hasError('description', 'minlength')">Must be atleast 40 characters</mat-error>
            </mat-form-field>
        </form>
    </div>
    <div class="button-container" mat-dialog-actions>
        <button mat-raised-button (click)="onNoClick()">Close</button>
        <button mat-raised-button cdkFocusInitial color="accent" [disabled]="!containerForm.valid" (click)="createContainer(containerForm.value)">Add</button>
    </div>
</div>